import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { LoadingService } from './loading.service';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GroupAge } from '../models/group-age';
import { ApiService } from './api.service';
import { STATUS } from '../enums/status.enum';
import { Nationality } from '../models/nationality.model';
import { RequestService } from './request.service';
// import { EventEmitter } from 'stream';

enum STATE {
    SUCCESS = "SUCCESS",
    PROGRESS = "PROGRESS",
    FREE = "FREE"
}

@Injectable({
    providedIn: 'root'
})
export class DataService {
    //use for binding purpose
    fullName:string;
    baseUrl: string;
    id: string;
    groupAges: GroupAge[] = new Array();
    nationalities: Nationality[] = new Array();
    defaultImage: Blob;
    tooltipImage: Blob;
    data: { [key: string]: any };
    userImage: Blob;
    onImageLoad: EventEmitter<any> = new EventEmitter();

    private defaultImageSuccess: boolean = false;
    private defaultImageRequesting: STATE = STATE.FREE;
    private requestingUserImage: STATE = STATE.FREE;

    constructor(
        private http: HttpClient,
        private router: Router,
        private request: RequestService,
        private api: ApiService,
        private loadingService:LoadingService
    ) {
        this.baseUrl = environment.API_URL;        
    }
    getDefaultImage(): Promise<Blob> {
        return new Promise((data, error) => {
            if (this.defaultImageSuccess && this.defaultImageRequesting == STATE.SUCCESS) {
                data(this.defaultImage);
            }
            if (this.defaultImageRequesting == STATE.FREE) {
                this.defaultImageRequesting = STATE.PROGRESS;
                this.http.get('/assets/img/default-pic.webp', {
                    responseType: 'blob'
                })
                .subscribe(
                    response => {
                        this.defaultImageSuccess = true;
                        this.defaultImage = response;
                        data(this.defaultImage);
                    },
                    error,
                    () => {
                        this.defaultImageRequesting = STATE.SUCCESS;
                    }
                );
                return;
            }
            this.getDefaultImage()
            .then(data)
            .catch(error)
        })
    }

    saveData(key, value): { [key:string]: any } {
        const data = { key: value };
        Object.assign(this.data, data);
        return data;
    }

    deleteData(key): { [key:string]: any } {
        const data = { key: this.data[key] };
        delete this.data[key];
        return data;
    }

    getTooltipImage(): void {
        this.http.get<Blob>('/assets/img/photo-tooltip.webp', {
            responseType: 'blob' as any
        })
        .subscribe(response => {
            this.tooltipImage = response;
        });
    }
    getUserImage(): void {
        this.request.get(environment.API_URL + 'user/avatar', null, false, 'blob')
        .subscribe(response => {
            if (response.constructor == Blob) {
                this.userImage = response;
                this.onImageLoad.emit(this.userImage);
            }
        });
    }
    getImage(): Promise<Blob> {
        return new Promise((resovle, error) => {
            switch (this.requestingUserImage) {
                case STATE.FREE:
                    this.requestingUserImage = STATE.PROGRESS;
                    this.request.get(environment.API_URL + 'user/avatar', null, false, 'blob')
                    .subscribe(response => {
                        if (response.constructor == Blob) {
                            this.userImage = response;
                            resovle(response);
                            this.requestingUserImage = STATE.SUCCESS;
                        } else {
                            resovle(this.defaultImage)
                        }
                    });
                    break;
                case STATE.PROGRESS:
                    return this.getImage()
                    .then(resovle)
                    .catch(error)
                case STATE.SUCCESS:
                    return resovle(this.userImage)
            }
        })
    }
    getGroupAge(): void {
        this.api.getGroupAge()
        .subscribe(
            response => {
                if (response.status != STATUS.SUCCESS) return;
                this.groupAges = response.data.group_ages;
            }
        );
    }
    getNationalities(): void {
        this.api.getNationalities()
        .subscribe(
            response => {
                if (response.status != STATUS.SUCCESS) return;
                this.nationalities = response.data.nationalities;
            }
        )
    }
    getNationalityById(id: string): Nationality {
        return this.nationalities.find(nationality => nationality._id == id) || {} as Nationality;
    }
    getGroupAgeById(id: string): GroupAge {
        return this.groupAges.find(age => age._id == id) || {} as GroupAge;
    }
    saveToken(token) {
        //this.data.token = token;
        localStorage.setItem("token", token);
    }

    setName(firstName: string,lastName: string) {
        localStorage.setItem('first_name', firstName);
        localStorage.setItem('last_name', lastName);
        this.fullName=localStorage.getItem('first_name')+" "+localStorage.getItem("last_name")
    }

    getToken(): string {
        //return this.data.token;
        return localStorage.getItem("token");
    }

    getBearerToken(): string {
        return 'Bearer ' + localStorage.getItem("token");
    }

    getVersion() {
        return '1.0.0';
    }

    getFullName() {
        if(localStorage.getItem('first_name')&&localStorage.getItem("last_name")){
            this.fullName=localStorage.getItem('first_name')+" "+localStorage.getItem("last_name")
        }else{
            this.fullName="";
        }
        
        return this.fullName;
    }

    getFirstName() {
        return localStorage.getItem('first_name');
    }

    getLastName() {
        return localStorage.getItem("last_name");
    }
    
    /**
     * @param {string} returnUrl Url that return after logout.
     * @param {string} returnLoginUrl Url that return after login success.
     * */
    logout(returnUrl="login",returnLoginUrl?){
        localStorage.removeItem('token');
        localStorage.removeItem('first_name');
        localStorage.removeItem('last_name');
        this.router.navigate([returnUrl], { queryParams: { returnUrl:  returnLoginUrl }});
    }

    postJSON(url: string, data: any,isAlertOnError:boolean=false) {
        this.loadingService.setLoading(true);
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.http.post<any>(url, data, { headers }).pipe(
            map(res => {
                this.loadingService.setLoading(false);
                if (res.status == 401) {
                    this.logout("login",this.router.url);
                } else if(res.status!=1&&isAlertOnError){
                    // this.dialog.open(MessageComponent, {
                    //     data:{
                    //       message:res.message,
                    //       isConfirm:false,
                    //     },
                    //     disableClose: false, role: 'dialog'
                    //   });
                }
                return res;
            }));
    }


    post(url: string, data: any) {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        this.loadingService.setLoading(true);
        return this.http.post<any>(url, data, { headers: headers }).pipe(
            map(res => {
                this.loadingService.setLoading(false);
                if (res.status == 401) {
                    this.logout("login",this.router.url);
                }
                return res;
            }));
    }

    getJSON(url: string,isAlertOnError:boolean=false) {
        this.loadingService.setLoading(true);
        return this.http.get<any>(url).pipe(
            map(res => {
                this.loadingService.setLoading(false);
                if (res.status == 401) {
                    this.logout("login",this.router.url);
                }
                else if(res.status!=1&&isAlertOnError){
                    // this.dialog.open(MessageComponent, {
                    //     data:{
                    //       message:res.message,
                    //       isConfirm:false,
                    //     },
                    //     disableClose: false, role: 'dialog'
                    //   });
                }
                return res;
            })
        );
    }
    
    checkToken() {
        this.loadingService.setLoading(true);
        return this.http.get<any>(
            this.baseUrl+"/api/check_token",
            {
                params:   {token:localStorage.getItem("token")}
            }
        ).pipe(
            map(res => {
                this.loadingService.setLoading(false);
                return res;
            })
        );
    }
}
